import { isApiError, isNetworkError } from '@/lib/api/types';

const operationLabel = (operation: string): string => {
  const label = operation.trim().replace(/[.!]+$/, '');
  if (!label || /\b(failed|error saving|login)\b/i.test(label)) {
    return 'No se pudo completar la operación';
  }
  return /^(no se pudo|error al|error de|ha ocurrido|fallo al)/i.test(label)
    ? label
    : `No se pudo ${label}`;
};

export function formatApiError(error: unknown, operation = 'completar la operación'): string {
  const context = operationLabel(operation);

  if (isNetworkError(error)) {
    return `${context}. Comprueba la conexión e inténtalo de nuevo.`;
  }
  if (isApiError(error)) {
    if (error.status === 401) {
      return error.code === 'SESSION_EXPIRED'
        ? `${context}. La sesión ha caducado. Inicia sesión de nuevo.`
        : `${context}. ${error.message || 'Comprueba tus credenciales e inicia sesión de nuevo.'}`;
    }
    if (error.status === 403) {
      return `${context}. Credenciales inválidas.`;
    }
    if (error.status >= 500) {
      const reference = error.errorId ? ` Referencia para soporte: ${error.errorId}.` : '';
      return `${context}. Ha ocurrido un error en el servidor. Inténtalo de nuevo.${reference}`;
    }
    if (error.status === 409) {
      return `${context}. ${error.message || 'Hay un conflicto con los datos actuales.'}`;
    }
    if (error.status === 400 || error.status === 422) {
      return `${context}. ${error.message || 'Revisa los datos introducidos.'}`;
    }
    if (error.status === 404) {
      return `${context}. No se encontró el recurso solicitado.`;
    }
    return `${context}. ${error.message || 'Inténtalo de nuevo.'}`;
  }
  return `${context}. Inténtalo de nuevo.`;
}
